if (!customElements.get('sooler-collection-carousel')) {
  customElements.define('sooler-collection-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.viewport = this.querySelector('[data-sooler-collection-viewport]');
      this.track = this.querySelector('.sooler-collection-carousel__track');
      this.cards = Array.from(this.querySelectorAll('[data-sooler-collection-card]'));
      this.previousButton = this.querySelector('[data-sooler-collection-prev]');
      this.nextButton = this.querySelector('[data-sooler-collection-next]');

      this.onPrevious = () => this.scrollByCard(-1);
      this.onNext = () => this.scrollByCard(1);
      this.onScroll = () => this.updateButtons();
      this.onResize = () => this.updateButtons();

      this.previousButton?.addEventListener('click', this.onPrevious);
      this.nextButton?.addEventListener('click', this.onNext);
      this.viewport?.addEventListener('scroll', this.onScroll, { passive: true });

      if ('ResizeObserver' in window && this.viewport) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.viewport);
      }

      requestAnimationFrame(() => this.updateButtons());
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.onPrevious);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.viewport?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
      this.initialized = false;
    }

    scrollByCard(direction) {
      const firstCard = this.cards[0];
      if (!firstCard || !this.viewport || !this.track) return;
      const gap = Number.parseFloat(getComputedStyle(this.track).gap) || 0;
      const distance = firstCard.getBoundingClientRect().width + gap;
      this.viewport.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }

    updateButtons() {
      if (!this.viewport) return;
      const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      if (this.previousButton) this.previousButton.disabled = this.viewport.scrollLeft <= 2;
      if (this.nextButton) this.nextButton.disabled = maxScroll <= 2 || this.viewport.scrollLeft >= maxScroll - 2;
    }
  });
}
